import analyticService from "../services/analytic";
import { message } from "antd";

const namespaces = "analytic";

const initialState = {
  trendingItemsData: null,
  data: null,
  loading: {
    fetchTrendingItems: false,
    fetchByDateRange: false,
    fetchSales: false,
  },
};

export const fetchTrendingItems = () => ({
  type: `${namespaces}/fetchTrendingItems`,
});

export const fetchByDateRange = (params) => ({
  type: `${namespaces}/fetchByDateRange`,
  payload: params,
});

export const fetchSales = () => ({
  type: `${namespaces}/fetchSales`,
});

export default {
  namespace: namespaces,
  state: initialState,
  effects: {
    *fetchSales(_, { call, put }) {
      yield put({ type: "startLoading", loadingType: "fetchSales" });
      try {
        const response = yield call(analyticService.fetchSales);
        yield put({ type: "setData", response });
      } catch (error) {
        console.error(error);
        message.error(error.message);
      } finally {
        yield put({ type: "stopLoading", loadingType: "fetchSales" });
      }
    },

    *fetchByDateRange({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "fetchByDateRange" });
      try {
        const response = yield call(analyticService.fetchByDateRange, payload);

        yield put({ type: "setSalesData", response });
        yield put({ type: "stopLoading", loadingType: "fetchByDateRange" });
      } catch (error) {
        console.error(error);
        message.error(error.message);
      }
    },
    *fetchTrendingItems(_, { call, put }) {
      yield put({ type: "startLoading", loadingType: "fetchTrendingItems" });
      try {
        const response = yield call(analyticService.fetchTrendingItems);
        yield put({ type: "setTrendingItemsData", response });
        yield put({ type: "stopLoading", loadingType: "fetchTrendingItems" });
      } catch (error) {
        message.error(error.message);
        console.error(error);
      }
    },
  },
  reducers: {
    setTrendingItemsData(state, { response }) {
      return { ...state, trendingItemsData: response.data.trendingProducts };
    },
    setSalesData(state, { response }) {
      return {
        ...state,
        data: {
          ...state.data,
          currentDayAnalytics:
            response.data.salesData._sum.total_sales !== null
              ? response.data.salesData._sum
              : null,
        },
      };
    },
    setData(state, { response }) {
      return { ...state, data: response.data.sales };
    },
    startLoading(state, { loadingType }) {
      return { ...state, loading: { ...state.loading, [loadingType]: true } };
    },
    stopLoading(state, { loadingType }) {
      return { ...state, loading: { ...state.loading, [loadingType]: false } };
    },
  },
};
